<template>
    <div class="exception-body notfound">
        <img v-if="showLogo" src="layout/images/logo-white.svg" alt="diamond-layout" class="logo" />

        <div class="exception-content">
            <div class="exception-title">WHOOPS!</div>
            <div class="exception-detail">La pagina non esiste, oppure è stata cancellata.</div>
            <router-link to="/">Torna alla Dashboard</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showLogo: {
            type: Boolean,
            required: false,
            default: true
        }
    }
};
</script>